// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1TJ4m","image":"App_image__2B0x-"};